import { HttpContextToken } from '@angular/common/http';

/**
 * Marca una petición para que `ResponseInterceptor` no la absorba.
 *
 * Por defecto el interceptor abre un modal global ante cualquier error y emite el
 * `HttpErrorResponse` como si fuera una respuesta válida. Las peticiones marcadas con este
 * token reciben el error propagado, de modo que el servicio o el componente que las lanzó
 * pueda manejarlo y dibujar su propio estado de error.
 */
export const OMITIR_ERROR_GLOBAL = new HttpContextToken<boolean>(() => false);
